/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for LicenceServerResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { LicenceServerProduct, GetLicenceServersByCustomerIdResponse } from "../models";

@Injectable({ providedIn: "root" })
export class LicenceServerResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getOwnLicenceServerProducts(resourceOptions: HttpResourceOptions<LicenceServerProduct, unknown> & { defaultValue: NoInfer<LicenceServerProduct> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<LicenceServerProduct>;
    getOwnLicenceServerProducts(resourceOptions?: HttpResourceOptions<LicenceServerProduct, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<LicenceServerProduct | undefined>;
    /** The licence server is resolved from the authenticated machine token; no route parameters are needed. */
    getOwnLicenceServerProducts(resourceOptions?: HttpResourceOptions<LicenceServerProduct, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<LicenceServerProduct | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/LicenceServer/M2M/Products`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getLicenceServersByCustomerId(customerId: Signal<number> | number, resourceOptions: HttpResourceOptions<GetLicenceServersByCustomerIdResponse, unknown> & { defaultValue: NoInfer<GetLicenceServersByCustomerIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicenceServersByCustomerIdResponse>;
    getLicenceServersByCustomerId(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetLicenceServersByCustomerIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicenceServersByCustomerIdResponse | undefined>;
    getLicenceServersByCustomerId(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetLicenceServersByCustomerIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicenceServersByCustomerIdResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const customerIdValue = typeof customerId === 'function' ? customerId() : customerId;
            if (customerIdValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, customerIdValue, 'customerId');
            }
            return {
                url: `${this.basePath}/LicenceServer`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getLicenceServerProducts(clientGuid: Signal<string> | string, serverReference: Signal<string> | string, resourceOptions: HttpResourceOptions<LicenceServerProduct, unknown> & { defaultValue: NoInfer<LicenceServerProduct> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<LicenceServerProduct>;
    getLicenceServerProducts(clientGuid: Signal<string> | string, serverReference: Signal<string> | string, resourceOptions?: HttpResourceOptions<LicenceServerProduct, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<LicenceServerProduct | undefined>;
    getLicenceServerProducts(clientGuid: Signal<string> | string, serverReference: Signal<string> | string, resourceOptions?: HttpResourceOptions<LicenceServerProduct, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<LicenceServerProduct | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/LicenceServer/${typeof clientGuid === 'function' ? clientGuid() : clientGuid}/${typeof serverReference === 'function' ? serverReference() : serverReference}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
